import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * [active] - boolean;
 *
 * [color] - SwitchColor;
 *
 * [size] - 'small' | 'middle' | 'big';
 *
 * (onToggle) - EventEmitter<boolean>;
 *
 * SwitchColor = {color: 'green' | 'scarlet' | 'blue' | 'violet', disableDefault: boolean}
 */

export interface SwitchColor {
  color: string;
  disableDefault: boolean;
}

@Component({
  selector: 'brn-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent implements OnInit {

  @Input() active: boolean = false;
  @Input() color: SwitchColor = {color: 'green', disableDefault: false};
  @Input() size: string = 'small';
  @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  toggle() {
    this.onToggle.emit(this.active);
    this.active = !this.active
  }

}
